module.exports = __webpack_public_path__ + "img/remove.273c86b8.svg";